import { IndexModel } from "../Support/IndexModel";
import { axios } from "../Support/Axios";
export class CampaignCodeOrderIndex extends IndexModel {
    account;
    slug;
    order;
    endpoint = '';
    constructor(params) {
        super();
        this.account = params.account;
        this.slug = params.slug;
        this.order = params.order;
        this.endpoint = 'code/' + this.order;
    }
    getData() {
        return super.getData();
    }
    checkReference(reference) {
        let url = '/api/code/' + this.order + '/check';
        return axios.post(url, {
            reference: reference
        }).catch(e => this.setError(e));
    }
}
